











'use strict';

var PropTypes=require('react').PropTypes;

var PointPropType=require('./createStrictShapeTypeChecker')({
x:PropTypes.number,
y:PropTypes.number});


module.exports=PointPropType;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/propTypes/PointPropType.js
// module id = 730
// module chunks = 0